import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import { homePageSchema, LOGO_URL } from '../schema/siteSchema';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Subscription Management & Billing Support | LearnWebCare"
        description="Get support for subscription management, billing, account questions, and cancellation. LearnWebCare provides after-sales support through trained customer service agents."
        canonicalUrl="https://learnwebcare.com/"
        ogTitle="Subscription Management & Billing Support | LearnWebCare"
        ogDescription="Get support for subscription management, billing, account questions, and cancellation. LearnWebCare provides after-sales support through trained customer service agents."
        ogUrl="https://learnwebcare.com/"
        ogImage={LOGO_URL}
        schema={homePageSchema}
      />
      <Header />
      <Hero />
      <TrustBar />
      <Features />
      <Footer />
    </div>
  );
}
